import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import 'react-perfect-scrollbar/dist/css/styles.css';
import ScrollBar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNotificationState } from './NotificationProvider';
import SettingList from './SettingList';
import * as action from './store/notification.action';
import NotificationList from './NotificationList';
import '../../Components/Notification/notification.css';
import { clearAllUserNotification } from '../../services/notification.service';

function UserNotification({ isShow, closeNotification }) {
  const { notState, setNotificationState, retriveNotificationSetting } = useNotificationState();
  const { settingView, settingModuleArray, chatEmailEnabled } = notState;
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const notificationList = useSelector((state) => state?.UserNotificationDetails?.notificationList) ?? [];
  const hasNotifications = Array.isArray(notificationList) && notificationList.length > 0;

  // Tab switcher logic
  const [currentTab, setCurrentTab] = useState(settingView ? 'settings' : 'notifications');
  const handleTabClick = useCallback(
    (tab) => {
      setCurrentTab(tab);
      if (tab === 'settings') setNotificationState((prev) => ({ ...prev, settingView: true }));
      else setNotificationState((prev) => ({ ...prev, settingView: false }));
    },
    [setNotificationState],
  );

  const saveNotificationSetting = () => {
    dispatch(action.saveSetting(settingModuleArray, chatEmailEnabled, t));
  };

  const clearNotifications = async (e) => {
    e?.stopPropagation();
    await clearAllUserNotification();
    const reqObj = { pageIndex: 1, pageSize: 20 };
    dispatch(action.fetchNotificationList(reqObj, t));
  };

  const resetSettings = async (e) => {
    e?.stopPropagation();
    await closeNotification();
  };

  return (
    <Modal className="custom-modal modal-504 right notification-modal" show={isShow} onHide={closeNotification}>
      <Modal.Header className="notification-modal-header">
        <div className="notification-header-left">
          {settingView && (
            <button className="btn btn-notification-save" type="button" onClick={saveNotificationSetting}>
              {t('NOTIFICATION_INDEX.SAVE')}
            </button>
          )}
        </div>
        <div className="notification-header-center">
          <Modal.Title className="notification-modal-title">
            {settingView ? t('NOTIFICATION_INDEX.NOTIFICATION_SETTINGS') : t('NOTIFICATION_INDEX.NOTIFICATIONS')}
          </Modal.Title>
        </div>
        <div className="notification-header-right">
          {settingView ? (
            <i className="icon-close f-24 cursor-pointer mt-2" onClick={resetSettings} />
          ) : (
            <button disabled={!hasNotifications} className="btn btn-notification-clear" type="button" onClick={clearNotifications}>
              {t('NOTIFICATION_INDEX.CLEAR_ALL')}
            </button>
          )}
        </div>
      </Modal.Header>

      {/* Tab Switcher UI */}
      <div className="common-switch-container-notification">
        <ul className="new-switch" data-active={currentTab === 'notifications' ? '0' : '1'}>
          <li className={currentTab === 'notifications' ? 'active' : ''}>
            <button type="button" className="switch-item" onClick={() => handleTabClick('notifications')}>
              {t('NOTIFICATION_INDEX.NOTIFICATIONS')}
            </button>
          </li>
          <li className={currentTab === 'settings' ? 'active' : ''}>
            <button type="button" className="switch-item" onClick={() => handleTabClick('settings')}>
              {t('NOTIFICATION_INDEX.SETTINGS')}
            </button>
          </li>
        </ul>
      </div>

      <Modal.Body className={settingView ? 'notification-settings-body' : ''}>
        {settingView ? (
          <div className="notification-settings-inner common-scrollbar">
            <div className="setting-list ">
              <SettingList />
            </div>
          </div>
        ) : (
          <div className="notification-list-outer">
            <NotificationList />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

UserNotification.propTypes = {
  isShow: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
};

export default UserNotification;
